<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white  p-15 p-sm-20 p-md-25"
    >
      <div class="row mb-3">
        <div class="col-md-3 mb-2">
          <label class="form-label">Magasin :</label>
          <v-select
            class="custom-select-height"
            v-model="client_filter"
            label="name"
            :options="clientList"
            @search="filterClients"
          />
        </div>
        <div class="col-md-2 mb-2">
          <label class="form-label">Agence :</label>
          <v-select
            class="custom-select-height"
            v-model="agency_filter"
            label="name"
            :options="agenciesList"
          />
        </div>
        <div class="col-md-2 mb-2">
          <label class="form-label">Statut :</label>
          <select v-model="status_filter" class="form-select">
            <option value="" selected>Status (Tous)</option>
            <option value="0">Pas encore reçu</option>
            <option value="1">Réçu</option>
          </select>
        </div>
        <!-- <div class="col-md-4 mb-2">
        <label class="form-label">Archivé :</label>
        <select v-model="filter.searchArchive" class="form-select">
          <option value="" selected>(Tous)</option>
          <option value="1">Archivé</option>
          <option value="0">Non Archivé</option>
        </select>
      </div> -->
        <div class="col-md-3 mb-2">
          <label class="form-label">Date de création:</label>
          <div class="border p-2 cursor-pointer" @click="showCalendar()">
            {{ selectedDate?.[0]?.format("DD MMM YYYY") || "—" }}
            -
            {{ selectedDate?.[1]?.format("DD MMM YYYY") || "—" }}
            <i class="flaticon-calendar float-end"></i>
          </div>

          <div
            v-show="showCalendarBox"
            class="position-relative mt-2 p-2 bg-white shadow rounded"
            style="z-index: 999"
          >
            <MyDateRangePicker
              v-model="selectedDate"
              @onSelect="showCalendar"
              :enableSecondCalendar="true"
            />
          </div>
        </div>
        <div class="col-md-2 d-flex align-items-end mb-2">
          <button
            type="button"
            class="btn btn-primary me-2"
            @click="filterList"
          >
            <i class="flaticon-search"></i>
          </button>
          <button type="button" class="btn btn-danger" @click="removeFilter">
            <i class="flaticon-close"></i>
          </button>
        </div>
      </div>
      <div class="d-lg-flex align-items-center justify-content-between ">
        <div class="d-sm-flex align-items-center">
          <router-link
            to="/add-product"
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
            v-if="auth.can('STOCK')"
          >
            Nouveau Produit
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </router-link>
        </div>
        <div class="d-sm-flex align-items-center">
          <form class="search-box position-relative">
            <input
              type="text"
              class="form-control shadow-none text-black rounded-0 border-0"
              placeholder="Search lead"
            />
            <!-- <button
              type="submit"
              class="bg-transparent text-primary transition p-0 border-0"
            >
              <i class="flaticon-search-interface-symbol"></i>
            </button> -->
          </form>
          <!-- <div
            class="select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0"
          >
            <i class="flaticon-calendar lh-1 icon"></i>
            <input
              ref="leadCalendar"
              type="text"
              class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16"
              id="lead-calendar"
            />
          </div> -->
        </div>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Produit
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Magasin
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Agence
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Quantité
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Statut
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date de réception
              </th>

              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="index">
              <th class="shadow-none fw-medium text-black title ps-0">
                <div class="d-flex align-items-center">
                  <b>
                    <img :src="row.pic" class="me-15" width="44" />
                    {{ row?.name }} <br />
                  </b>
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ row.customer_name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ row.stock_agency_name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span v-for="item in row.inventories" :key="item.id">
                  <center>
                    <b>{{ item.inventory_ref }}</b> {{ item.qty }} |
                    {{ item.qty_not_received }}
                    <span
                      class="badge bg-outline-danger"
                      v-if="item.archived == 1"
                    >
                      Archivé </span
                    ><br />
                  </center>
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span
                  v-if="row.received == 1"
                  class="badge text-bg-success rounded-pill"
                >
                  Reçu
                </span>

                <span class="badge text-bg-warning rounded-pill" v-else>
                  Pas encore reçu
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <template v-if="row.received_time">
                  {{ getDate(row.received_time) }}
                </template>
              </td>
              <td
                class="shadow-none lh-1 fw-medium text-paragraph text-end pe-0"
              >
                <div class="dropdown">
                  <button
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        v-if="auth.can('STOCK')"
                        class="dropdown-item d-flex align-items-center"
                        @click.prevent="
                          $router.push({
                            name: 'EditProductPage',
                            params: { id: row.id },
                          })
                        "
                        ><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier</a
                      >
                    </li>
                    <li>
                      <a
                        v-if="auth.can('STOCK')"
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="archiveProduct(row)"
                        ><i
                          class="flaticon-delete lh-1 me-8 position-relative top-1"
                        ></i>
                        Archiver</a
                      >
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
      >
        <p class="mb-0 text-paragraph">
          Showing
          <span class="fw-bold">
            {{ (filter.current_page - 1) * filter.per_page + 1 }}
          </span>
          –
          <span class="fw-bold">
            {{ Math.min(filter.current_page * filter.per_page, filter.total) }}
          </span>
          out of <span class="fw-bold">{{ filter.total }}</span> results
        </p>

        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <!-- Previous -->
            <li
              class="page-item"
              :class="{ disabled: filter.current_page === 1 }"
            >
              <a
                class="page-link"
                href="javascript:void(0)"
                aria-label="Previous"
                @click="goToPage(filter.current_page - 1)"
              >
                ‹
              </a>
            </li>

            <!-- First page -->
            <li v-if="pages[0] !== 1" class="page-item">
              <a
                class="page-link"
                href="javascript:void(0)"
                @click="goToPage(1)"
                >1</a
              >
            </li>

            <!-- Left dots -->
            <li v-if="pages[0] > 2" class="page-item disabled">
              <span class="page-link">...</span>
            </li>

            <!-- Main pages -->
            <li v-for="page in pages" :key="page" class="page-item">
              <a
                href="javascript:void(0)"
                class="page-link"
                :class="{ active: filter.current_page === page }"
                @click="goToPage(page)"
              >
                {{ page }}
              </a>
            </li>

            <!-- Right dots -->
            <li
              v-if="pages[pages.length - 1] < filter.last_page - 1"
              class="page-item disabled"
            >
              <span class="page-link">...</span>
            </li>

            <!-- Last page -->
            <li
              v-if="pages[pages.length - 1] !== filter.last_page"
              class="page-item"
            >
              <a
                class="page-link"
                href="javascript:void(0)"
                @click="goToPage(filter.last_page)"
              >
                {{ filter.last_page }}
              </a>
            </li>

            <!-- Next -->
            <li
              class="page-item"
              :class="{ disabled: filter.current_page === filter.last_page }"
            >
              <a
                class="page-link"
                href="javascript:void(0)"
                aria-label="Next"
                @click="goToPage(filter.current_page + 1)"
              >
                ›
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Filter -->

  <div class="modal fade" id="archiveModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Archivation des produits</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <table class="table table-responsive mb-0">
            <thead>
              <tr>
                <th v-for="field in fields" :key="field.key">
                  {{ field.label || field.key }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in inventoriesRow" :key="row.id">
                <td>
                  <span class="text-nowrap">{{ row.inventory_ref }}</span>
                </td>
                <td>
                  <span class="text-nowrap">{{ row.qty }}</span>
                </td>
                <td>
                  <span class="text-nowrap">{{ row.qty_not_received }}</span>
                </td>
                <td>
                  <span class="text-nowrap">
                    <span
                      v-if="row.archived == 1"
                      class="badge text-bg-danger rounded-pill fs-13"
                    >
                      Archivé
                    </span>
                    <span
                      v-else
                      class="badge text-bg-success rounded-pill fs-13"
                    >
                      Activé
                    </span>
                  </span>
                </td>
                <td>
                  <button
                    v-if="row.archived == 0 && (row.qty == 0 || row.qty < 0)"
                    class="btn btn-danger"
                    title="Archiver La variante"
                    @click="$emit('archiveVariant', row)"
                  >
                    <i
                      class="flaticon-check-mark lh-1 me-8 position-relative top-1"
                    ></i>
                  </button>
                  <button
                    v-if="row.archived == 1"
                    class="btn btn-success"
                    title="Désarchiver La variante"
                    @click="$emit('archiveVariant', row)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAuthStore } from "../../stores/auth";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import { computed } from "vue";
import { Modal } from "bootstrap";
import MyDateRangePicker from "@/components/MyDateRangePicker.vue";

export default {
  name: "ProductListPage",
  components: {MyDateRangePicker},
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);

    const filter = reactive({
      surrent_page: 1,
      per_page: 10,

      searchMagazin: "",
      searchAgency: "",
      searchStatus: "",
      searchArchive: "",
      searchDate: "",
      searchEDate:"",

      // (optional) pagination/meta from API:
      total: 0,
      last_page: 1,
      current_page: 1,
    });

    const client_filter = ref({ id: "", name: "" });
    const city_filter = ref({ id: "", name: "" });
    const agency_filter = ref({ id: "", name: "" });
    const status_filter = ref(null);

    const searchTerm = ref("");

    interface Status {
      code: string;
      name: string;
      code_color?: string;
    }

    const status = ref<Status[]>([]);

    const clientList = ref<Status[]>([]);
    const agenciesList = ref<Status[]>([]);

    const fields = [
      { key: "inventory_ref", label: "Variante" },
      { key: "qty", label: "Quantité Restée" },
      { key: "qty_not_received", label: "Quantité Reçue" },
      { key: "statut", label: "Statut" },
      { key: "actions", label: "Archiver" },
    ];
    const inventoriesRow = ref([]);

    function getDate(value) {
      if (value) return moment(String(value)).format("YYYY-MM-DD HH:mm");
      else return "";
    }

    function buildQuery() {
      const params = new URLSearchParams({
        // searchTerm: filter.searchTerm || "",
        searchMagazin: filter.searchMagazin || "",
        searchAgency: filter.searchAgency || "",
        searchStatus: filter.searchStatus || "",
        searchArchive: filter.searchArchive || "",
        searchDate: filter.searchDate || "",
        searchEDate: filter.searchEDate || "",


        page: String(filter.current_page || 1),
        per_page: String(filter.per_page || 10),
      });
      return `/api/auth/list_product?${params.toString()}`;
    }

    onMounted(async () => {
      flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
      });

      flatpickr("#basic-calendar", {
        dateFormat: "Y-m-d H:i",
      });
      getRecords();
      fetchAgencies();
    });

    const pages = computed(() => {
      const windowSize = 2; // show 2 before/after current page
      const start = Math.max(1, filter.current_page - windowSize);
      const end = Math.min(filter.last_page, filter.current_page + windowSize);

      let arr = [];
      for (let i = start; i <= end; i++) {
        arr.push(i);
      }
      return arr;
    });

    async function getRecords() {
      isLoader.value = true;
      try {
        const url = buildQuery();
        const { data } = await api.get(url);

        rows.value = data.users.data;

        // Keep your search fields; only update pagination/meta you need:
        filter.current_page = data.users.current_page;
        filter.per_page = data.users.per_page;
        filter.total = data.users.total;
        filter.last_page = data.users.last_page;

        // If you actually need all fields returned from backend:
        // Object.assign(users, { ...users, ...data.users })
      } finally {
        isLoader.value = false;
      }
    }

    const todayDt = moment();
    const firstDt = moment().subtract(8, "M");
    const selectedDate = ref(null);

    const showCalendarBox = ref(false);

    function showCalendar() {
      showCalendarBox.value = !showCalendarBox.value;
    }

    function filterList() {
      filter.searchAgency = agency_filter.value?.id || "";
      filter.searchMagazin = client_filter.value?.id || "";
      //   filter.searchDate = liv_filter.value?.id || "";
      //   filter.searchArchive = etat_filter.value || "";
      //   filter.searchTerm = searchTerm.value || "";
      filter.searchStatus = status_filter.value || "";

   
      filter.searchDate = selectedDate.value?.[0]
        ? selectedDate.value[0].format("YYYY-MM-DD")
        : "";

      filter.searchEDate = selectedDate.value?.[1]
        ? selectedDate.value[1].format("YYYY-MM-DD")
        : "";

      filter.current_page = 1;
      getRecords();
    }

    function removeFilter() {
      // reset users filters
      filter.searchMagazin = "";
      filter.searchAgency = "";
      filter.searchStatus = "";
      filter.searchArchive = "";
      filter.searchDate = "";
      filter.searchEDate = "";

       selectedDate.value = null;

      //   filter.searchTerm = "";
      filter.current_page = 1;

      // reset local UI models

      searchTerm.value = "";

      agency_filter.value = { id: "", name: "" };
      client_filter.value = { id: "", name: "" };
      status_filter.value = null;
      // clear date range picker model
      //   if (!myInput.value) myInput.value = { dateRange: {} }
      //   myInput.value.dateRange = {}

      getRecords();
    }

    async function fetchAgencies() {
      try {
        const response = await api.get("/api/auth/AgencyStock");
        if (response && response.data) {
          agenciesList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching statuses:", error);
      }
    }

    function goToPage(page) {
      if (page < 1 || page > filter.last_page) return;
      filter.current_page = page;
      getRecords();
    }

    function globalHelper(s: string) {
      if (!s || s === "undefined") {
        return null; // always return null for invalid values
      }

      return status.value.find((o) => o.code === s) || null;
    }

    function removeHours(value) {
      if (value && value !== "") {
        const datePart = value.split(" ")[0];
        return datePart;
      }
    }
    function reported(date) {
      const currentDate = new Date();
      const reportedDate = new Date(date);
      if (reportedDate.getTime() <= currentDate.getTime()) {
        return true;
      } else {
        return false;
      }
    }
    function resolveStatuParcel(status) {
      if (status === "POSTPONED") return "Reporté";
      if (status === "DELIVERED") return "Livré";
      if (status === "PAID") return "Payé";
      if (status === "NOT_PAID") return "Non Payé";
      if (status === "Payé") return "Payé";
      if (status === "CANCELED") return "Annulé";
      if (status === "UNREACHABLE") return "Injoignable";
      if (status === "POSTPONED") return "Reporté";
      if (status === "RETURNED") return "Retourné";
      if (status === "RECEIVED") return "Reçu";
      if (status === "OUT_OF_AREA") return "Hors-zone";
      if (status === "NOANSWER") return "Pas de réponse + SMS";
      if (status === "SENTED") return "Expédié";
      if (status === "REFUSE") return "Refusé";
      if (status === "ONV") return "En Voyage";
      if (status === "INT") return "Client intéréssé";
      if (status === "POSTPONED_TEAM") return "Reporté ( SUIVI )";
      if (status === "CANCELED_TEAM") return "Annulé ( SUIVI )";
      if (status === "VOICEMAIL_TEAM") return "Boite Vocal ( SUIVI )";
      if (status === "EN") return "Erreur Numéro";
      return status;
    }

    function resolveUserStatusVariant(status) {
      if (status === "PICKED_UP") return "warning";
      if (status === "DELIVERED") return "success";
      if (status === "PAID") return "info";
      if (status === "NOT_PAID") return "danger";
      if (status === "Payé") return "info";
      if (status === "Non Payé") return "warning";
      if (status === "Facturé") return "info";
      return "primary";
    }

    function getStatusName(code?: string) {
      return code ? globalHelper(code)?.name || "" : "";
    }

    function getStatusColor(code?: string) {
      return code ? globalHelper(code)?.code_color || "#000" : "#000";
    }

    let debounceTimeout: number | undefined;

    async function filterClients(search: string, loading: { value: boolean }) {
      const query = search.trim().toLowerCase();

      if (!query) {
        clientList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/ListCustsFilter`, {
            params: { query },
          });
          clientList.value = res.data;
          clientList.value.unshift({ code: "", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          clientList.value = [];
        }
      }, 300); // 300ms debounce
    }

    function archiveProduct(row) {
      inventoriesRow.value = [];
      console.log(row);
      if (row && row.inventories) {
        // row.inventories.forEach(item => inventoriesRow.value.push(item));
        inventoriesRow.value = row.inventories;
      }
      const modalEl = document.getElementById("archiveModal");
      if (modalEl) {
        const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
        modal.show();
      }
    }

    return {
      auth,
      rows,
      goToPage,
      filter,
      getDate,
      globalHelper,
      removeHours,
      reported,
      resolveStatuParcel,
      resolveUserStatusVariant,
      client_filter,
      city_filter,
      status_filter,
      agency_filter,
      searchTerm,
      agenciesList,
      clientList,
      status,

      filterClients,
      filterList,
      removeFilter,

      pages,
      fields,
      inventoriesRow,
      archiveProduct,

      selectedDate,
      firstDt,
      todayDt,
      showCalendar,
      showCalendarBox,
    };
  },
};
</script>